var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Header'),_c('div',{staticClass:"clearfix"}),_c('BannerInner',{attrs:{"PageTitle":_vm.$route.name}}),_c('div',{staticClass:"container-fluid mt-5"},[_c('SideMenu'),_c('router-view')],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }